/**
 * Normalizes a human label into a stable, lowercase, hyphenated test id fragment.
 * Trailing counts that some UI labels carry (e.g. "Properties 5", "Service Requests 3")
 * are stripped so the id stays stable as data changes.
 *
 * Used by shared primitives (nav items, buttons, action-menu items) to expose
 * `data-testid` hooks for Selenium/automation without coupling tests to visible text.
 */
export const toTestId = (label: unknown): string =>
  String(label ?? "")
    .replace(/\s+\d+\s*$/, "") // drop a trailing count like " 5"
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
